export default {
  SET_CURRENT_SUBSCRIPTION(state, subscription) {
    state.currentSubscription = subscription;
  },
  SET_PRICE_BREAKDOWN(state, breakdown) {
    state.priceBreakdown = breakdown;
  },
  SET_CLIENT_SECRET(state, secret) {
    state.clientSecret = secret;
  },
  SET_PAYMENT_STATUS(state, status) {
    state.paymentStatus = status;
  },
  RESET_PAYMENT_STATE(state) {
    state.currentSubscription = null;
    state.priceBreakdown = null;
    state.clientSecret = null;
    state.paymentStatus = null;
  },
};
